import {HTTP} from "@/utils/httpCommonUtil";
import {ImportLeads} from "@/components/providers/models/ImportLeadsInterface";

export async function importLeads(data: ImportLeads) {
  const response = await HTTP.post(`/api/providers/import-leads`, data);
  return response.data;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/providers/services/ImportProvidersService.ts